/** @format */

/**
 * お知らせ設定
 */

import {SnackbarProvider, VariantType, useSnackbar} from 'notistack';
import {
  FormGroup,
  Checkbox,
  FormControlLabel,
  Container,
  Box,
  Stack,
} from '@mui/material';
import {Fragment, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

//API import
import {patchSettingUser} from '../../API/API_Collection';
//MTH component import
import {PrimaryButton} from '../../component/BasicButton';
//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {useUserInfo} from '../my-site/MainMySite';

const Notifications = () => {
  const {enqueueSnackbar} = useSnackbar();
  //ユーザ情報取得
  const {userInfo} = useUserInfo();

  const [checked1, setChecked1] = useState(false); //1行目のチェックボックス
  const [checked2, setChecked2] = useState(false); //2行目のチェックボックス
  const [checked3, setChecked3] = useState(false); //3行目のチェックボックス
  const [checked4, setChecked4] = useState(false); //4行目のチェックボックス

  const trans = useTranslation().t; //翻訳関数

  useEffect(() => {
    if (userInfo !== null) {
      if (userInfo.notifications['alarm-manage-site'] === 'active') {
        setChecked1(true);
      }
      if (userInfo.notifications['alarm-monitor-site'] === 'active') {
        setChecked2(true);
      }
      if (userInfo.notifications['maintenance-manage-site'] === 'active') {
        setChecked3(true);
      }
      if (userInfo.notifications['connect-manage-site'] === 'active') {
        setChecked4(true);
      }
    }
  }, [userInfo]);

  /**
   * 1行目のチェックボックス押下時の処理
   * @param event
   */
  const handleChange1 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked1(event.target.checked);
  };
  /**
   * 2行目のチェックボックス押下時の処理
   * @param event
   */
  const handleChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked2(event.target.checked);
  };
  /**
   * 3行目のチェックボックス押下時の処理
   * @param event
   */
  const handleChange3 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked3(event.target.checked);
  };
  /**
   * 4行目のチェックボックス押下時の処理
   * @param event
   */
  const handleChange4 = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked4(event.target.checked);
  };

  /**
   * SAVEボタン押下時の処理
   */
  const onClickSave = async () => {
    let variant: VariantType;

    const body: apiIF.reqParameters.patchSettingUser = {
      notifications: {
        'alarm-manage-site': checked1 ? 'active' : 'inactive',
        'alarm-monitor-site': checked2 ? 'active' : 'inactive',
        'maintenance-manage-site': checked3 ? 'active' : 'inactive',
        'connect-manage-site': checked4 ? 'active' : 'inactive',
      },
    };
    patchSettingUser(body)
      .then(response => {
        variant = 'success';
        enqueueSnackbar(trans('Notifications.executionResult.successMsg'), {
          variant,
        });
        setTimeout(() => window.location.reload(), 2000);
      })
      .catch(err => {
        variant = 'error';
        enqueueSnackbar(trans('Notifications.executionResult.failureMsg'), {
          variant,
        });
      });
  };

  return (
    <Container fixed className="accountSetting">
      <Stack spacing={3}>
        {/** タイトル */}
        <Box>
          <h1>{trans('Notifications.title')}</h1>
        </Box>
        <Stack>
          <Box className="accountSetting__text__instruction">
            <h3>{trans('Notifications.instruction')}</h3>
          </Box>
          <FormGroup>
            {/* 1行目のチェックボックス */}
            <FormControlLabel
              control={
                <Checkbox onChange={handleChange1} id={'notificationChkbox1'} />
              }
              checked={checked1}
              label={trans(
                'Notifications.checkboxDescription.receiveErrAdminSite'
              )}
            />
            {/* 2行目のチェックボックス */}
            <FormControlLabel
              control={
                <Checkbox onChange={handleChange2} id={'notificationChkbox2'} />
              }
              checked={checked2}
              label={trans(
                'Notifications.checkboxDescription.receiveErrManagerViewerSite'
              )}
            />
            {/* 3行目のチェックボックス */}
            <FormControlLabel
              control={
                <Checkbox onChange={handleChange3} id={'notificationChkbox3'} />
              }
              checked={checked3}
              label={trans(
                'Notifications.checkboxDescription.receiveMaintenanceNotification'
              )}
            />
            {/* 4行目のチェックボックス */}
            <FormControlLabel
              control={
                <Checkbox onChange={handleChange4} id={'notificationChkbox4'} />
              }
              checked={checked4}
              label={trans(
                'Notifications.checkboxDescription.receiveNotificationNewUserInvited'
              )}
            />
          </FormGroup>
          <Box
            className="accountSetting__button"
            display="flex"
            justifyContent="flex-end">
            <Fragment>
              <PrimaryButton
                onClick={onClickSave}
                buttonText={trans('Notifications.buttonTxt.save')}
                id="mv-notifSaveBtn"
              />
            </Fragment>
          </Box>
        </Stack>
      </Stack>
    </Container>
  );
};
const Main = () => {
  //SnackbarProviderはuseSnackbar()と同じコンポーネントにできないため分割した
  return (
    <SnackbarProvider maxSnack={3}>
      <Notifications />
    </SnackbarProvider>
  );
};
export default Main;
